import { showErrorToast } from "src/components/AlertToastify/AlertToastify";
import { UserPreferencesData } from "src/mockup/UserPreferencesData";

export const getUserPreferences = async (accessToken: string,signal?: AbortSignal): Promise<UserPreferencesData> => {
  const maxRetries = 3;
  const retryDelay = 500;

  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/preferences`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
        signal: signal,
        credentials: "include",
      });

      if (response.status === 404 && attempt < maxRetries - 1) {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
        continue;
      }

      if (!response.ok) {
        throw new Error(`Failed to load preferences: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      if (attempt === maxRetries - 1) {
        showErrorToast("Error to get user preferences");
        throw error;
      }
      await new Promise((resolve) => setTimeout(resolve, retryDelay));
    }
  }
  throw new Error("Could not get user preferences");
};
